import { getPlatform } from "@/features/identity/constants/platforms";

const MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => MAP[c]);
const bare = (url) => url.replace(/^https?:\/\//, "").replace(/\/$/, "");
const FONT = "Arial, Helvetica, sans-serif";
const INK = "#15161A";
const MUTED = "#55575E";
const ACCENT = "#1F3A5F";
const a = (href, text, style = "") => `<a href="${esc(href)}" style="color:${INK};text-decoration:none;${style}">${esc(text)}</a>`;

// Email-client-safe signature: tables + inline styles, raster images only.
export function buildSignatureHtml(id, { qrSrc } = {}) {
  const contact = [
    id.email && a(`mailto:${id.email}`, id.email),
    id.phone && a(`tel:${id.phone.replace(/[^\d+]/g, "")}`, id.phone),
    id.website && a(id.website, bare(id.website)),
  ].filter(Boolean);
  const socials = id.links.map((l) => a(l.url, getPlatform(l.platform).label, `color:${ACCENT};`)).join(`<span style="color:#B4B7BE;">&nbsp;·&nbsp;</span>`);
  const photo = id.photoUrl
    ? `<td valign="top" style="padding:0 16px 0 0;"><img src="${esc(id.photoUrl)}" width="84" height="84" alt="${esc(id.fullName)}" style="display:block;width:84px;height:84px;border-radius:42px;border:0;object-fit:cover;"></td>`
    : "";
  const side = id.logoUrl || qrSrc
    ? `<td valign="top" align="center" style="padding:0 0 0 16px;">${id.logoUrl ? `<img src="${esc(id.logoUrl)}" height="40" alt="${esc(id.company)}" style="display:block;height:40px;max-width:120px;border:0;margin:0 auto 10px;">` : ""}${qrSrc ? `<img src="${esc(qrSrc)}" width="84" height="84" alt="QR code" style="display:block;width:84px;height:84px;border:0;margin:0 auto;">` : ""}<div style="font-family:${FONT};font-size:9px;letter-spacing:2px;color:#8A8C92;padding-top:6px;">METWORTH</div></td>`
    : "";
  return `<table cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;font-family:${FONT};font-size:13px;line-height:1.5;color:${INK};"><tr>${photo}<td valign="top" style="padding:0 16px 0 0;border-right:1px solid #DAD8D2;">${
    id.fullName ? `<div style="font-size:17px;font-weight:bold;color:${INK};">${esc(id.fullName)}</div>` : ""
  }${id.title ? `<div style="color:${MUTED};">${esc(id.title)}</div>` : ""}${id.company ? `<div style="font-weight:bold;color:${INK};">${esc(id.company)}</div>` : ""}<div style="height:1px;line-height:1px;background:#DAD8D2;margin:10px 0;width:180px;">&nbsp;</div>${contact.join("<br>")}${
    socials ? `<div style="padding-top:8px;">${socials}</div>` : ""
  }${id.publicProfileUrl ? `<div style="padding-top:8px;">${a(id.publicProfileUrl, "View my MetWorth profile →", `color:${ACCENT};font-weight:bold;`)}</div>` : ""}</td>${side}</tr></table>`;
}

export function buildSignatureText(id) {
  return [id.fullName, [id.title, id.company].filter(Boolean).join(" · "), id.email, id.phone, id.website, id.publicProfileUrl && `MetWorth profile: ${id.publicProfileUrl}`]
    .filter(Boolean)
    .join("\n");
}
